import { Serializable } from '../../../../_shared/model/deserialize.service';
import { FileSource } from '../enums/file-source.enum';

export class DocumentData implements Serializable<DocumentData> {
    documentId: string;
    description: string;
    contentType: string;
    fileName: string;
    fileSource: FileSource;

    deserialize(input) {
        this.documentId = input.documentId;
        this.description = input.description;
        this.contentType = input.contentType;
        this.fileName = input.fileName;
        this.fileSource = input.fileSource;
        return this;
    }
}
